// src/PayslipPage.js - MODIFICATO CON LOGICA "CARICA E SOSTITUISCI" E FIX VISUALIZZAZIONE

import React, { useState, useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useUser } from './UserContext';
import { db, storage } from './firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
// --- INIZIO MODIFICA: Import aggiuntivi necessari ---
import { 
    collection, getDocs, addDoc, query, where, 
    onSnapshot, orderBy, deleteDoc, doc, updateDoc // Aggiunto updateDoc
} from 'firebase/firestore';
// --- FINE MODIFICA ---
import { toast } from 'react-toastify';
import moment from 'moment';
import './PayslipPage.css';
import Select from 'react-select';
import { logAction } from './loggingService';

// --- Componente Admin (Uploader) ---
function PayslipManager({ staffList }) {
    const { userProfile } = useUser();
    const queryClient = useQueryClient();
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(moment().subtract(1, 'month').format('YYYY-MM'));
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    // --- ✅ FIX 1: Non mappare nuovamente staffList, è già nel formato corretto ---
    // La prop 'staffList' arriva già come [{ value: 'id', label: 'Nome', ... }]
    const staffOptions = staffList;
    // --- FINE FIX 1 ---

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            const file = e.target.files[0];
            if (file.type !== "application/pdf") {
                 toast.error("Puoi caricare solo file PDF.");
                 e.target.value = null;
                 setSelectedFile(null);
                 return;
            }
            setSelectedFile(file);
        }
    };

    // --- INIZIO MODIFICA: Logica "Carica e Sostituisci" in handleUpload ---
    const handleUpload = async () => {
        if (!userProfile.centerId) {
        toast.error("Errore: centerId non disponibile.");
        setIsUploading(false);
        return;
    }
    const centerId = userProfile.centerId;
        if (!selectedUser || !selectedFile || !selectedMonth) {
            toast.error("Seleziona utente, mese e file.");
            return;
        }
        
        setIsUploading(true);
        const file = selectedFile;
        const userId = selectedUser.value;
        const userName = selectedUser.label;
        const monthYear = selectedMonth;

        try {
            // 1. Controlla se esiste già una busta paga per questo utente/mese
            const q = query(
            collection(db, 'centers', centerId, 'payslips'), // <-- MODIFICA PERCORSO
                where('userId', '==', userId),
                where('monthYear', '==', monthYear)
            );
            const existingDocs = await getDocs(q);
            let oldSlip = null;

            if (!existingDocs.empty) {
                // Trovata una busta paga esistente
                oldSlip = { 
                    id: existingDocs.docs[0].id, 
                    ...existingDocs.docs[0].data() 
                };
                
                // Chiedi conferma per la sostituzione
                if (!window.confirm(`Esiste già una busta paga per ${userName} (${moment(monthYear).format('MM/YYYY')}).\nVuoi sostituirla con il nuovo file? Il vecchio file sarà eliminato.`)) {
                    setIsUploading(false);
                    return; // Interrompi l'operazione
                }
            }

            // 2. Carica il NUOVO file su Storage
            const storagePath = `payslips/${userId}/${monthYear}_${file.name}`;
            const storageRef = ref(storage, storagePath);
            const snapshot = await uploadBytes(storageRef, file);
            const downloadURL = await getDownloadURL(snapshot.ref);

            // 3. Prepara i nuovi dati per Firestore
            const payslipData = {
                userId: userId,
                userName: userName,
                monthYear: monthYear,
                fileName: file.name,
                fileUrl: downloadURL,
                storagePath: storagePath,
                uploadedAt: new Date(),
            uploadedBy: userProfile.uid,
            centerId: centerId, // <-- AGGIUNGI centerId
        };

            if (oldSlip) {
                // 4a. SOSTITUISCI: Aggiorna il documento Firestore esistente
                const docRef = doc(db, 'centers', centerId, 'payslips', oldSlip.id); // <-- MODIFICA PERCORSO
                await updateDoc(docRef, payslipData);

                // 5a. Elimina il VECCHIO file da Storage (se diverso)
                if (oldSlip.storagePath && oldSlip.storagePath !== storagePath) {
                    try {
                        const oldStorageRef = ref(storage, oldSlip.storagePath);
                        await deleteObject(oldStorageRef);
                    } catch (storageError) {
                        console.warn(`Impossibile eliminare il vecchio file storage (${oldSlip.storagePath}):`, storageError);
                        // Non blocchiamo l'operazione se il vecchio file non si trova
                    }
                }
                
                await logAction(userProfile, `ha SOSTITUITO la busta paga per ${userName} (${monthYear})`);
                toast.success(`Busta paga per ${userName} (${monthYear}) sostituita!`);

            } else {
                // 4b. CREA: Aggiungi un nuovo documento Firestore
                await addDoc(collection(db, 'centers', centerId, 'payslips'), payslipData); // <-- MODIFICA PERCORSO
                await logAction(userProfile, `ha CARICATO la busta paga per ${userName} (${monthYear})`);
                toast.success(`Busta paga per ${userName} (${monthYear}) caricata!`);
            }

            // Aggiorna la cache
            queryClient.invalidateQueries({ queryKey: ['payslips', centerId, userId] });

            // Reset
            setSelectedFile(null);
            setSelectedUser(null);
            document.getElementById('file-input').value = null; 

        } catch (error) {
            console.error("Errore durante il caricamento:", error);
            toast.error("Errore durante il caricamento: " + error.message);
        } finally {
            setIsUploading(false);
        }
    };
    // --- FINE MODIFICA ---

    return (
        <div className="payslip-manager">
            <h3>Carica Busta Paga</h3>
            <div className="upload-form">
                <div className="form-group">
                    <label>Dipendente</label>
                    <Select
                        options={staffOptions}
                        value={selectedUser}
                        onChange={setSelectedUser}
                        placeholder="Seleziona dipendente..."
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        menuPortalTarget={document.body}
                    />
                </div>
                <div className="form-group">
                    <label>Mese/Anno</label>
                    <input type="month" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} />
                </div>
                <div className="form-group">
                    <label>File (solo PDF)</label>
                    <input id="file-input" type="file" accept="application/pdf" onChange={handleFileChange} />
                </div>
                <button onClick={handleUpload} disabled={isUploading} className="upload-button">
                    {isUploading ? 'Caricamento...' : 'Carica e Salva'}
                </button>
            </div>
        </div>
    );
}

// --- Componente Utente (Downloader) ---
function MyPayslips({ userId, isManagerView }) {
    const { userProfile } = useUser();
    const queryClient = useQueryClient();

    const { data: payslips = [], isLoading } = useQuery({
        queryKey: ['payslips', userProfile?.centerId, userId],
        queryFn: async () => {
            const q = query(
                collection(db, 'centers', userProfile.centerId, 'payslips'),
                where('userId', '==', userId),
                orderBy('monthYear', 'desc')
            );
            const snapshot = await getDocs(q);
            return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        },
        enabled: !!(userId && userProfile?.centerId)
    });

    // Questa è l'eliminazione "secca" per correggere un errore
    const handleDelete = async (slip) => {
        if (!window.confirm(`Sei sicuro di voler eliminare DEFINITIVAMENTE la busta paga di ${slip.userName} per ${moment(slip.monthYear).format('MMMM YYYY')}? L'azione non è reversibile.`)) {
            return;
        }

        try {
            // 1. Elimina il file da Storage
            const fileRef = ref(storage, slip.storagePath);
            await deleteObject(fileRef);
            
            // 2. Elimina il documento da Firestore
            await deleteDoc(doc(db, 'centers', userProfile.centerId, 'payslips', slip.id)); // <-- MODIFICA PERCORSO
            
            queryClient.invalidateQueries({ queryKey: ['payslips', userProfile.centerId, slip.userId] });
            await logAction(userProfile, `ha ELIMINATO la busta paga di ${slip.userName} (${slip.monthYear})`);
            toast.warn("Busta paga eliminata.");
        } catch (error) {
            console.error("Errore eliminazione busta paga:", error);
            toast.error("Errore durante l'eliminazione.");
        }
    };

    if (isLoading) {
        return <p>Caricamento buste paga...</p>;
    }

    return (
        <div className="my-payslips">
            <h3>{isManagerView ? 'Buste Paga Caricate' : 'Le tue Buste Paga'}</h3>
            {payslips.length === 0 ? (
                <p>{isManagerView ? 'Nessuna busta paga trovata per questo utente.' : 'Nessuna busta paga trovata.'}</p>
            ) : (
                <ul className="payslip-list">
                    {payslips.map(slip => (
                        <li key={slip.id}>
                            <span className="payslip-month">{moment(slip.monthYear, 'YYYY-MM').format('MMMM YYYY')}</span>
                            <span className="payslip-filename">{slip.fileName}</span>
                            <a href={slip.fileUrl} target="_blank" rel="noopener noreferrer" className="download-button">
                                Scarica
                            </a>
                            {isManagerView && (
                                <button onClick={() => handleDelete(slip)} className="delete-button" title="Elimina Definitivamente">
                                    🗑️
                                </button>
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

// --- Componente Principale Pagina ---
function PayslipPage() {
    const { userProfile } = useUser();
    const [selectedUserForView, setSelectedUserForView] = useState(null);
    const permission = userProfile?.permissions?.payslips || 'none';

    // Modifica: solo 'completo' e 'super admin' (implicito) possono caricare E VEDERE gli altri
    const isManager = permission === 'completo' || permission === 'semi-completo' || userProfile?.role === 'Super Admin';
    // 'semi-completo' e 'viewer' vedono solo le proprie
    const canViewSelf = permission !== 'none';

    const { data: staffList = [] } = useQuery({
        queryKey: ['staff', userProfile?.centerId],
        queryFn: async () => {
            const staffSnapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'staff'));
            return staffSnapshot.docs
                .map(doc => ({ value: doc.id, label: `${doc.data().personalData?.firstName || doc.data().name} ${doc.data().personalData?.lastName || ''}`.trim(), ...doc.data() }))
                .sort((a, b) => a.label.localeCompare(b.label));
        },
        enabled: !!(isManager && userProfile?.centerId)
    });

    const staffOptions = staffList;

    return (
        <div className="payslip-page-container">
            {isManager && (
                <>
                    <PayslipManager staffList={staffList} />
                    <div className="payslip-manager-viewer">
                        <h4>Visualizza e Gestisci Buste Paga Caricate</h4>
                        <Select
                            options={staffOptions}
                            value={selectedUserForView}
                            onChange={setSelectedUserForView}
                            placeholder="Seleziona un dipendente per vedere i file..."
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9998 }) }}
                            menuPortalTarget={document.body}
                            isClearable
                        />
                        {/* Mostra la lista solo se un utente è selezionato */}
                        {selectedUserForView && (
                             <MyPayslips userId={selectedUserForView.value} isManagerView={true} />
                        )}
                    </div>
                </>
            )}
            {/* Se non sei manager, ma hai il permesso di vederle, vedi solo le tue */}
            {!isManager && canViewSelf && (
                <MyPayslips userId={userProfile.uid} isManagerView={false} />
            )}
        </div>
    );
}

export default PayslipPage;